module.exports = __webpack_public_path__ + "static/media/plus-icon.756767d2.svg";